/**
 * XHR-based upload helper that exposes onProgress.
 * RTK Query's fetchBaseQuery doesn't support upload progress events natively
 * (fetch streams in only Node 18+/limited browsers), so for file uploads we
 * fall back to XMLHttpRequest.
 *
 * Returns a Promise<{ data, status }>.
 * Throws { status, data } on non-2xx (mirroring RTK error shape).
 */
export function uploadWithProgress({
  url,
  method = 'POST',
  formData,
  token,
  onProgress,
  signal,
}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);

    if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);

    if (xhr.upload && typeof onProgress === 'function') {
      xhr.upload.onprogress = (evt) => {
        if (evt.lengthComputable) {
          const pct = Math.round((evt.loaded / evt.total) * 100);
          onProgress(pct, { loaded: evt.loaded, total: evt.total });
        }
      };
    }

    xhr.onload = () => {
      let data;
      try {
        data = xhr.responseText ? JSON.parse(xhr.responseText) : null;
      } catch {
        data = xhr.responseText;
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({ data, status: xhr.status });
      } else {
        reject({ status: xhr.status, data });
      }
    };

    xhr.onerror = () => reject({ status: 0, data: { message: 'Сеть недоступна' } });
    xhr.onabort = () => reject({ status: 0, data: { message: 'Загрузка отменена' } });

    if (signal) {
      if (signal.aborted) {
        xhr.abort();
        return;
      }
      signal.addEventListener('abort', () => xhr.abort(), { once: true });
    }

    xhr.send(formData);
  });
}

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
